import * as $ from 'jquery';
import { IDialog, IDialogOptions } from 'runtime/dialogs/dialog';
import { IResourceProvider } from 'common/resourceprovider';

export class ConfirmProcessDialog implements IDialog {
    private $dialogContent: JQuery;
    options: IDialogOptions;

    constructor(resources: IResourceProvider, selectedCount: number, confirmAction: () => void, cancelAction: () => void) {
        let message = selectedCount === 1 
            ? resources.getCoreString('ConfirmBulkActionDialogTextSingle')
            : resources.getCoreString('ConfirmBulkActionDialogText')?.replace('{0}', selectedCount.toString());
        
        this.options = {
            title: resources.getCoreString('ConfirmBulkActionDialogTitle'),
            width: 350,
            dialogClass: 'wf-worktray-item-dialog',
            buttons: [
                { 
                    text: resources.getCoreString('XamlProcess'), 
                    click: (): void => {
                        confirmAction();
                        this.$dialogContent.dialog('close');
                    }
                },
                { 
                    text: resources.getCoreString('XamlCancel'), 
                    click: (): void => {
                        cancelAction();
                        this.$dialogContent.dialog('close');
                    }
                }
            ]
        };

        this.$dialogContent = $('<div />').append([
            $('<div />').addClass('form-group').append([
                $('<div />').text(message)
            ])
        ]);
    }

    content() {
        return this.$dialogContent;
    }
}